import React from 'react';
import PropTypes from 'prop-types';
import { KeyboardDatePicker } from '@material-ui/pickers';
import TextField from './TextField';

const propTypes = {
  label: PropTypes.string.isRequired,
  value: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.shape({}),
  ]),
  onChange: PropTypes.func.isRequired,
};

const defaultProps = {
  value: null,
};

function DatePicker(props) {
  const {
    label, value, onChange, ...others
  } = props;


  function handleDateChange(date) {
    onChange(date);
  }

  return (
    <KeyboardDatePicker
      // disableToolbar
      autoOk
      okLabel=""
      cancelLabel=""
      format="DD/MM/YYYY"
      inputVariant="outlined"
      invalidDateMessage=""
      label={label}
      value={value}
      onChange={handleDateChange}
      TextFieldComponent={TextField}
      {...others}
    />
  );
}

DatePicker.propTypes = propTypes;

DatePicker.defaultProps = defaultProps;

export default DatePicker;
